import React from 'react';
import { LoadingSpinner, VStack } from '@adc/parallax-component-library';
const Spinner = ({ testID = '' }) => {
    return (React.createElement(VStack, { padding: "$4", backgroundColor: "$surface.background", display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", zIndex: 1, style: {
            height: '100vh',
            width: '100vw',
        } },
        React.createElement(LoadingSpinner, { testID: `${testID}.spinner` })));
};
export { Spinner };
